import { useQuery } from '@tanstack/react-query'
import { BookingEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetBooking(bookingId: string): {
  booking: BookingEntity | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: booking,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(getBookingQueryKey(bookingId), async () => {
    return qoursesApi.payment.paymentControllerGetBookingV1(bookingId)
  })

  return { booking, isLoading, isError, refetch, isRefetching }
}

export const getBookingQueryKey = (bookingId: string) => ['booking', bookingId]
